/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Provider_UnavailableInputs */

const vi_einvoice_error_provider_unavailable = /** @type {(inputs: Einvoice_Error_Provider_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA đang gặp lỗi dịch vụ tạm thời. Vui lòng thử lại sau vài phút.`)
};

/**

* @param {Einvoice_Error_Provider_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_provider_unavailable = /** @type {((inputs?: Einvoice_Error_Provider_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Provider_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_provider_unavailable(inputs)
});